const PrincipalDesk = () => {
    return (
        <div id="principal" className="about-message container">
            <div className="message-left">
                <img src="https://picsum.photos/300/350" alt="director" />
            </div>

            <div className="message-right">
                <h2>Principal's Desk</h2>
                <p>
                    Dear Students and Parents,
                </p><br />
                <p>
                    Welcome to Nav Jeevan Mission School! Nav Jeevan Mission School is committed to providing a positive, challenging, and academic learning environment, for all students. Our goal is to provide learning activities which require high levels of critical thinking and reasoning. Additionally, our teachers provide support to our students by monitoring progress and tutoring as needed. Our teachers are experienced and dedicated professionals who are committed to helping all students reach their full potential. Success is not a matter of luck, but planning and organization. Our parents are an integral part of their student’s success. Our consistent support and encouragement of parents, result in greater success for all students.
                </p>
                <p>
                    I look forward to another successful school year. Please stay involved, and call on your child’s teacher, or administrator for any assistance you may need during this school year. We are here to help and support you in your schooling journey!
                </p>
                <h4>MR.CYRIL COSTA M</h4>
                <h4>- Principal -</h4>
            </div>

        </div>
    );
};

export default PrincipalDesk;